module.exports = __webpack_public_path__ + "static/img/10.ba975f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/10.png
// module id = vYyy
// module chunks = 0